import { render, staticRenderFns } from "./share-link.vue?vue&type=template&id=61f4e54c&scoped=true&"
import script from "./share-link.vue?vue&type=script&lang=ts&"
export * from "./share-link.vue?vue&type=script&lang=ts&"
import style0 from "./share-link.vue?vue&type=style&index=0&id=61f4e54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f4e54c",
  null
  
)

export default component.exports